export const translations = {
  en: {
    translation: {
      common: {
        en: 'English',
        ru: 'Russian',
        de: 'German',
        it: 'Italian',
        pl: 'Polish',
        auto: 'Auto',
        you: 'You',
        assistant: 'Assistant',
        error: 'Error',
        yes: 'Yes',
        no: 'No',
        next: 'Next',
        back: 'Back',
        select: 'Select',
        loading: 'Loading...',
        settings: 'Settings',
        profile: 'Profile',
        signOut: 'Sign Out',
        signIn: 'Sign In',
        signInGoogle: 'Sign In with Google',
        authorization: 'Authorization',
      },
      sidebar: {
        search: 'Search',
        capture: 'Capture',
        actions: 'Actions',
        cleanup: 'Cleanup',
        projects: 'Projects',
      },
      scopes: {
        inbox: 'Inbox',
        next: 'Next',
        waiting: 'Waiting',
        scheduled: 'Scheduled',
        someday: 'Someday/Maybe',
        reference: 'Reference',
        archived: 'Archive',
        trash: 'Trash',
        done: 'Done',
        focus: 'Focus',
        agenda: 'Agenda',
        pending: 'Pending',
      },
      filters: {
        all: 'All',
      },
      dates: {
        today: 'Today',
        yesterday: 'Yesterday',
        previous7Days: 'Previous 7 days',
        previous30Days: 'Previous 30 days',
        olderThan30Days: 'Older than 30 days',
      },
      actions: {
        new_task: 'New Task',
        new_project: 'New Project',
        create: 'Create',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        delete_project: 'Delete project',
        move: 'Move to...',
        trash: 'Trash',
        delete_current_instance: 'Delete Current Instance',
        delete_all_instances: 'Delete All Instances',
        edit_task: 'Edit Task',
        edit_project: 'Edit Project',
        add_reminder: 'Add reminder',
        discard: 'Discard',
        continue_editing: 'Continue editing',
        search: 'Search',
      },
      messages: {
        no_tasks: 'No tasks found',
        delete_project_confirm: 'Are you sure you want to delete this project? This action cannot be undone.',
        delete_task_confirm: 'Are you sure you want to delete this task?',
        delete_task_multi: 'This task has multiple instances. How would you like to delete it?',
        unsaved_changes: 'Unsaved changes',
        unsaved_changes_confirm: 'You have unsaved changes. Do you want to discard them?',
        save_error: 'Failed to save changes. Please try again.',
        task_not_found: 'Task not found or unavailable.',
        task_open_error: 'Failed to open task. Please try again.',
        searching: 'Searching...',
        no_results: 'No results found',
        search_placeholder: 'Search tasks...',
      },
      options: {
        none: 'None',
        energy_high: 'High',
        energy_medium: 'Medium',
        energy_low: 'Low',
        new_contact: '+ New Contact',
        dur_5min: '5 min',
        dur_10min: '10 min',
        dur_15min: '15 min',
        dur_30min: '30 min',
        dur_45min: '45 min',
        dur_1h: '1 hour',
        dur_2h: '2 hours',
        dur_3h: '3 hours',
        dur_4h: '4 hours',
        dur_6h: '6 hours',
        dur_8h: '8 hours',
        rem_5min: '5 min before',
        rem_15min: '15 min before',
        rem_30min: '30 min before',
        rem_1h: '1 hour before',
        rem_2h: '2 hours before',
        rem_4h: '4 hours before',
        rem_1d: '1 day before',
        rem_2d: '2 days before',
        rem_1w: '1 week before',
      },
    },
  },
  ru: {
    translation: {
      common: {
        en: 'английский',
        ru: 'русский',
        de: 'немецкий',
        it: 'итальянский',
        pl: 'польский',
        auto: 'Авто',
        you: 'Вы',
        assistant: 'Ассистент',
        error: 'Ошибка',
        yes: 'Да',
        no: 'Нет',
        next: 'Далее',
        back: 'Назад',
        select: 'Выбрать',
        loading: 'Загрузка...',
        settings: 'Настройки',
        profile: 'Профиль',
        signOut: 'Выйти',
        signIn: 'Войти',
        signInGoogle: 'Войти с Google',
        authorization: 'Авторизация',
      },
      sidebar: {
        search: 'Поиск',
        capture: 'Сбор',
        actions: 'Действия',
        cleanup: 'Очистка',
        projects: 'Проекты',
      },
      scopes: {
        inbox: 'Входящие',
        next: 'Следующие',
        waiting: 'В ожидании',
        scheduled: 'Запланированные',
        someday: 'Когда-нибудь',
        reference: 'Справочник',
        archived: 'Архив',
        trash: 'Корзина',
        done: 'Выполнено',
        focus: 'В фокусе',
        agenda: 'Повестка',
        pending: 'В ожидании',
      },
      filters: {
        all: 'Все',
      },
      dates: {
        today: 'Сегодня',
        yesterday: 'Вчера',
        previous7Days: 'Предыдущие 7 дней',
        previous30Days: 'Предыдущие 30 дней',
        olderThan30Days: 'Старше 30 дней',
      },
      actions: {
        new_task: 'Новая задача',
        new_project: 'Новый проект',
        create: 'Создать',
        close: 'Закрыть',
        cancel: 'Отмена',
        save: 'Сохранить',
        delete: 'Удалить',
        delete_project: 'Удалить проект',
        move: 'Переместить...',
        trash: 'В корзину',
        delete_current_instance: 'Удалить текущий экземпляр',
        delete_all_instances: 'Удалить все экземпляры',
        edit_task: 'Редактировать задачу',
        edit_project: 'Редактировать проект',
        add_reminder: 'Добавить напоминание',
        discard: 'Отменить',
        continue_editing: 'Продолжить редактирование',
        search: 'Поиск',
      },
      messages: {
        no_tasks: 'Задач не найдено',
        delete_project_confirm: 'Вы уверены, что хотите удалить этот проект? Это действие необратимо.',
        delete_task_confirm: 'Вы уверены, что хотите удалить эту задачу?',
        delete_task_multi: 'У этой задачи несколько экземпляров. Как вы хотите её удалить?',
        unsaved_changes: 'Несохранённые изменения',
        unsaved_changes_confirm: 'У вас есть несохранённые изменения. Отменить их?',
        save_error: 'Не удалось сохранить изменения. Попробуйте ещё раз.',
        task_not_found: 'Задача не найдена или недоступна.',
        task_open_error: 'Не удалось открыть задачу. Попробуйте ещё раз.',
        searching: 'Поиск...',
        no_results: 'Ничего не найдено',
        search_placeholder: 'Поиск задач...',
      },
      options: {
        none: 'Нет',
        energy_high: 'Высокая',
        energy_medium: 'Средняя',
        energy_low: 'Низкая',
        new_contact: '+ Новый контакт',
        dur_5min: '5 мин',
        dur_10min: '10 мин',
        dur_15min: '15 мин',
        dur_30min: '30 мин',
        dur_45min: '45 мин',
        dur_1h: '1 час',
        dur_2h: '2 часа',
        dur_3h: '3 часа',
        dur_4h: '4 часа',
        dur_6h: '6 часов',
        dur_8h: '8 часов',
        rem_5min: 'За 5 мин',
        rem_15min: 'За 15 мин',
        rem_30min: 'За 30 мин',
        rem_1h: 'За 1 час',
        rem_2h: 'За 2 часа',
        rem_4h: 'За 4 часа',
        rem_1d: 'За 1 день',
        rem_2d: 'За 2 дня',
        rem_1w: 'За 1 неделю',
      },
    },
  },
}
